export function pushData(dataObj) {
  const { gtmDataLayer } = window || {};
  if (!gtmDataLayer || typeof gtmDataLayer.push !== 'function') {
    return;
  }

  gtmDataLayer.push(dataObj);
}
